import axios from 'axios';

export const smoothHeaders = {
  accept: 'application/json, text/plain, */*',
};

export const smoothConfig = { headers: smoothHeaders };

export const postSmooth = (url, data = null) => axios.post(url, data, smoothConfig);

